
import LocationsIcon from "../images/LocationsIcon"
import LocationsActiveIcon from "../images/LocationsActiveIcon"
import Locations from "../page/Locations/Locations"
import CreateLocations from "../page/Locations/CreateLocations"
import Company from "../page/Company/Company"
import CompanyIcon from "../images/CompanyIcon"
import CompantIconActive from "../images/CompanyIconActive"
import LocationCompany from "../page/Company/LocationCompany"
import UserCompany from "../page/Company/UserCompany"
import FloorPlan from "../page/FloorPlan/FloorPlan"
import ListFloorPlan from "../page/FloorPlan/ListFloorPlan"
import Reservations from "../page/Reservations/Reservations"
import DeviceUserRole from "../page/Role/DeviceUserRole"
import DeviceUserRoleDetail from "../page/Role/DeviceUserRoleDetail"
const ConfigurationSideBar = [
    {
        index: 9,
        name: "Locations",
        show: true,
        showRoute: true,
        path: "/locations",
        component: Locations,
        image: LocationsIcon,
        imageActive: LocationsActiveIcon
    },
    {
        index: 10,
        name: "Locations",
        show: false,
        showRoute: true,
        path: "/locations/new",
        component: CreateLocations,
        image: LocationsIcon,
        imageActive: LocationsActiveIcon
    },
    {
        index: 11,
        name: "Locations",
        show: false,
        showRoute: true,
        path: "/locations/:id",
        component: CreateLocations,
        image: LocationsIcon,
        imageActive: LocationsActiveIcon
    },
    {
        index: 9,
        name: "Co. Details",
        show: true,
        showRoute: true,
        path: "/companies",
        component: Company,
        image: CompanyIcon,
        imageActive: CompantIconActive
    },
    {
        index: 10,
        name: "Co. Details",
        show: false,
        showRoute: true,
        path: "/companies/location/new",
        component: LocationCompany,
        image: CompanyIcon,
        imageActive: CompantIconActive
    },
    {
        index: 11,
        name: "Co. Details",
        show: false,
        showRoute: true,
        path: "/companies/location/:id",
        component: LocationCompany,
        image: CompanyIcon,
        imageActive: CompantIconActive
    },
    {
        index: 10,
        name: "Co. Details",
        show: false,
        showRoute: true,
        path: "/companies/user/new",
        component: UserCompany,
        image: CompanyIcon,
        imageActive: CompantIconActive
    },
    {
        index: 11,
        name: "Co. Details",
        show: false,
        showRoute: true,
        path: "/companies/user/:id",
        component: UserCompany,
        image: CompanyIcon,
        imageActive: CompantIconActive
    },
    {
        index: 12,
        name: "Co. Details",
        show: false,
        showRoute: true,
        path: "/companies/floorPlan/new",
        component: FloorPlan,
        image: CompanyIcon,
        imageActive: CompantIconActive
    },
    {
        index: 13,
        name: "Co. Details",
        show: false,
        showRoute: true,
        path: "/companies/floorPlan/:id",
        component: FloorPlan,
        image: CompanyIcon,
        imageActive: CompantIconActive
    },
    {
        index: 17,
        name: "Floor Plans",
        show: false,
        showRoute: true,
        path: "/floorPlan",
        component: ListFloorPlan,
        image: CompanyIcon,
        imageActive: CompantIconActive
    },
    {
        index: 18,
        name: "Floor Plans",
        show: false,
        showRoute: true,
        path: "/floorPlan/new",
        component: FloorPlan,
        image: CompanyIcon,
        imageActive: CompantIconActive
    },
    {
        index: 19,
        name: "Floor Plans",
        show: false,
        showRoute: true,
        path: "/floorPlan/:id",
        component: FloorPlan,
        image: CompanyIcon,
        imageActive: CompantIconActive
    },
    {
        index: 20,
        name: "Reservations Setup",
        show: false,
        showRoute: true,
        path: "/reservations",
        component: Reservations,
        image: CompanyIcon,
        imageActive: CompantIconActive
    },
    {
        index: 45,
        name: 'Device User Role',
        show: false,
        showRoute: true,
        path: '/deviceUserRole',
        component: DeviceUserRole,
        image: CompanyIcon,
        imageActive: CompantIconActive,
    },
    {
        index: 46,
        name: 'Device User Role',
        show: true,
        showRoute: true,
        path: '/deviceUserRole/:id',
        component: DeviceUserRoleDetail,
        image: CompanyIcon,
        imageActive: CompantIconActive,
    },

]
export default ConfigurationSideBar